import { Modal, Tooltip } from '@mantine/core';
import PrimaryButton from 'components/primaryButton';
import SecondaryButton from 'components/secondaryButton';
import { useEffect } from 'react';

import useMoveFilesAndFolder from '../../hooks/useMoveFilesAndFolders';
import useCopyFilesAndFolder from '../../hooks/useCopyFilesAndFolders';

const FailToMoveModal = ({
  failTOMoveData,
  setFailtoMoveData,
  failToMoveModal,
  setFailToMoveModal,
  closeModal,
  historyOfPath,
  message,
  isCopy,
}) => {
  function arrayRemove(arr, value) {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  }

  useEffect(() => {
    if (failToMoveModal) {
      if (failTOMoveData?.length === 0) {
        closeModal();
      }
    }
    // eslint-disable-next-line
  }, [failTOMoveData]);
  const moveFilesAndFoldersMutation = useMoveFilesAndFolder();
  const copyFilesAndFoldersMutation = useCopyFilesAndFolder();
  return (
    <div>
      <Modal
        opened={failToMoveModal}
        onClose={() => {
          setFailToMoveModal(false);
          setFailtoMoveData([]);
          closeModal();
        }}
        title={'Error to Update'}
        //   withCloseButton={false}
        overlayColor={'#F8F7F799'}
        overlayBlur={20}
        overlayOpacity={0.5}
        centered
        size={500}
        radius='md'
        overflow='inside'
        transitionDuration={100}
        classNames={{
          title: 'w-full text-center text-[#D0342C]  font-semibold text-18',
          modal: 'pl-10',
          body: 'scroller -mr-4 pr-2',
        }}
      >
        <p className='text-[#D0342C] text-sm font-semibold text-center'>
          {message}
          <br />
          Would you like to add this new file/files,
          <br />
          or rename it and keep them both?
        </p>
        <div className='flex flex-col my-5'>
          {failTOMoveData?.map((each) => {
            const filename = each?.split('/').pop();
            return (
              <div
                className='flex justify-between items-center'
                key={each?.name}
              >
                <Tooltip
                  label={filename}
                  classNames={{
                    body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
                  }}
                  radius='md'
                >
                  <p className='w-52 truncate'>{filename}</p>
                </Tooltip>
                <div>
                  <button
                    className='mx-1 my-1'
                    onClick={() => {
                      if (isCopy) {
                        copyFilesAndFoldersMutation.mutate({
                          files: [each],
                          to: historyOfPath,
                          replace: true,
                          force_upload: true,
                        });
                        setFailtoMoveData(arrayRemove(failTOMoveData, each));
                        
                      } else {
                        moveFilesAndFoldersMutation.mutate({
                          files: [each],
                          to: historyOfPath,
                          replace: true,
                          force_upload: true,
                        });
                        setFailtoMoveData(arrayRemove(failTOMoveData, each));
                      }
                    }}
                  >
                    <SecondaryButton>Replace</SecondaryButton>
                  </button>
                  <button
                    className='mx-1 my-1'
                    onClick={() => {
                      if (isCopy) {
                        copyFilesAndFoldersMutation.mutate({
                          files: [each],
                          to: historyOfPath,
                          replace: false,
                          force_upload: true,
                        });
                        setFailtoMoveData(arrayRemove(failTOMoveData, each));
                        
                      } else {
                        moveFilesAndFoldersMutation.mutate({
                          files: [each],
                          to: historyOfPath,
                          replace: false,
                          force_upload: true,
                        });
                        setFailtoMoveData(arrayRemove(failTOMoveData, each));
                      }
                    }}
                  >
                    <PrimaryButton>Keep both</PrimaryButton>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </Modal>
    </div>
  );
};

export default FailToMoveModal;
